import { AudioControlsProps } from "../../../types";
import AudioControls from "../../audio/AudioControls";

interface AvatarFooterProps {
  controls: AudioControlsProps;
}

const AvatarFooter = ({ controls }: AvatarFooterProps) => {
  return (
    <footer className="min-h-[100px] p-4 flex justify-center items-center bg-transparent relative z-10">
      <AudioControls
        isConnected={controls.isConnected}
        avatarReady={controls.avatarReady}
        isDisconnecting={controls.isDisconnecting}
        isSpeaking={controls.isSpeaking}
      />
    </footer>
  );
};

export default AvatarFooter;
